import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FlyoutAccountSummaryHeader } from '../../models/interfaces/account-summary-header.models';
import { BaseFlyoutSummaryHeaderComponent } from './base/base-flyout-summary-header.component';

@Component({
  selector: 'idp-flyout-account-summary-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flyout-account-summary-header.component.html',
  styleUrls: ['./flyout-account-summary-header.component.scss']
})
export class FlyoutAccountSummaryHeaderComponent extends BaseFlyoutSummaryHeaderComponent {
  @Input() content: FlyoutAccountSummaryHeader =
    {} as FlyoutAccountSummaryHeader;

  @Output() close = new EventEmitter<void>();

  private millionMilerSvgUrl: string | null = null;

  getHeaderGradient(): string {
    const medFlag = this.getMedallionFlag(
      this.content.membershipLevel,
      this.content.is360Tier,
      this.content.millionMiler
    );

    const gradients: { [key: string]: string } = {
      FO: 'linear-gradient(63.56deg, #454F58 22.11%, #5E6B77 78.02%)',
      GM: 'linear-gradient(66.41deg, #6C4F26 22.1%, #AC8545 78.13%)',
      PM: 'linear-gradient(65.39deg, #483E5D 22.15%, #726394 78.01%)',
      DM: 'linear-gradient(62.82deg, #385468 22.15%, #648EAC 78.02%)',
      DM360: 'linear-gradient(62.82deg, #101011 22.13%, #47494C 78.05%)',
      FF: 'linear-gradient(62.68deg, #2A3A73 22.21%, #5970C2 78.01%)',
      MM: this.getMillionMilerGradient()
    };

    return gradients[medFlag] || gradients['FF'];
  }

  getBottomContainerBg(): string {
    const medFlag = this.getMedallionFlag(
      this.content.membershipLevel,
      this.content.is360Tier,
      this.content.millionMiler
    );

    const backgrounds: { [key: string]: string } = {
      FF: '#2A3A73',
      FO: '#3A434A',
      GM: '#6C4F26',
      PM: '#483E5D',
      DM: '#385468',
      DM360: '#101011',
      MM: this.getMillionMilerBackground()
    };

    return backgrounds[medFlag] || backgrounds['FF'];
  }

  getMillionMilerGradient(): string {
    const baseGradients: { [key: string]: string } = {
      FO: 'linear-gradient(63.56deg, #454F58 22.11%, #5E6B77 78.02%)',
      GM: 'linear-gradient(66.41deg, #6C4F26 22.1%, #AC8545 78.13%)',
      PM: 'linear-gradient(65.39deg, #483E5D 22.15%, #726394 78.01%)',
      DM: 'linear-gradient(62.82deg, #385468 22.15%, #648EAC 78.02%)',
      FF: 'linear-gradient(62.68deg, #2A3A73 22.21%, #5970C2 78.01%)'
    };
    return baseGradients[this.content.membershipLevel] || baseGradients['FF'];
  }

  getMillionMilerBackground(): string {
    const baseBackgrounds: { [key: string]: string } = {
      FF: '#2A3A73',
      FO: '#3A434A',
      GM: '#6C4F26',
      PM: '#483E5D',
      DM: '#385468'
    };
    return (
      baseBackgrounds[this.content.membershipLevel] || baseBackgrounds['FF']
    );
  }

  getMillionMilerSvgUrl(): string {
    if (this.millionMilerSvgUrl) return this.millionMilerSvgUrl;
    if (!this.content.millionMilerTier) return '';

    const tier = this.content.millionMilerTier
      ? parseInt(this.content.millionMilerTier, 10).toString()
      : '0';
    this.millionMilerSvgUrl = `/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/million-miler/tracker-million-miler-${tier}.svg`;
    return this.millionMilerSvgUrl;
  }

  onClose(): void {
    this.close.emit();
  }
}
